import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Paper';
import { getBorderRadius } from 'Components/utils';
import useMobileLayout from 'Hooks/useMobileLayout';
import Minimized from './Minimized';

const styles = theme => ({
  root: {
    margin: theme.spacing(0, 2),
    ...getBorderRadius(theme.radius.md, { top: true }),
  },
  mobile: {
    margin: 0,
    maxWidth: '100vw',
  },
});

function Expanded({
  className,
  classes,
  item,
  ActionsProps,
  ChildComponent,
  ChildComponentProps,
  ...rest
}) {
  const isMobile = useMobileLayout();

  return (
    <Paper
      className={classNames(classes.root, className, { [classes.mobile]: isMobile })}
      variant={'tight'}
      {...rest}
    >
      <Minimized
        className={classes.header}
        clickable
        embedded
        item={item}
        ActionsProps={ActionsProps}
      />
      <ChildComponent
        {...ChildComponentProps}
      />
    </Paper>
  );
}

Expanded.defaultProps = {
  className: '',
  ChildComponentProps: {},
};

Expanded.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
  ActionsProps: PropTypes.object.isRequired,
  ChildComponent: PropTypes.object.isRequired,
  ChildComponentProps: PropTypes.object,
};

export default withStyles(styles)(Expanded);
